import React from "react"
import styled from "styled-components"
import {Flex} from "./Flex"

const HeaderLinks = (props) => {
  return (
    <Flex alignItems={props.alignItems} justifyContent={props.justifyContent}>
      {props.links.map((link, key) => {
        return (
          <LinkDiv isActive={link.isActive} key={key}>
            {link.name}
          </LinkDiv>
        )
      })}
    </Flex>
  )
}

const LinkDiv = styled.div`
  color: ${(props) => props.isActive && props.theme.colorPrimary};
  font-weight: ${(props) => props.isActive && 'bold'};
  padding: 0 1rem;
  position: relative;
  &::after {
    background-color: ${(props) => props.theme.colorPrimary};
    bottom: 0;
    content: "";
    display: ${(props) => (props.isActive ? "block" : "none")};
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
  }
`

HeaderLinks.defaultProps = {
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  links: [],
}

export {HeaderLinks}
